import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import produce from 'immer'
import { Button } from 'primereact/button'

import { useToastContext } from '../../../../../contexts/toast'
import { AllowanceCharge } from '../../../../../data/models'
import { getHandleableError } from '../../../../../utils/errors/isXiaError'
import { useConfigContext } from '../../../../ui-config/context'
import { requestPutAllowanceChargesById } from '../../../data'

type Props = {
  invoiceId: string
  selectedItems: AllowanceCharge[] | null | undefined
  setSelectedItems?: (params: any) => void
}

export const RejectAllowanceCharges: React.FC<Props> = ({
  invoiceId,
  selectedItems,
  setSelectedItems,
}) => {
  const { t } = useTranslation()
  const { showToast } = useToastContext()
  const { uiConfig: config } = useConfigContext()

  const [isRequestRunning, setIsRequestRunning] = useState<boolean>(false)

  async function onSubmit() {
    // deactivate the buttons
    setIsRequestRunning(true)

    try {
      // submit form
      submitForm()

      // deselect the items in the table
      if (setSelectedItems) {
        setSelectedItems([])
      }
      // show success toast
      showToast({
        style: {},
        closable: true,
        severity: 'success',
        summary: t(
          'invoice.allowanceCharges.table.reject.messages.success.summary',
          {
            type:
              selectedItems?.length &&
              selectedItems[0].ConfirmationAlcType === 'Surcharge'
                ? t('common.codes.alcType.surcharge')
                : t('common.codes.alcType.discount'),
            description:
              selectedItems?.length && selectedItems[0].ConfirmationDescription,
            count: selectedItems?.length,
          },
        ),
      })
    } catch (error) {
      let handleableError = getHandleableError(error)
      let errorMessage = handleableError.message

      // show error toast
      showToast({
        style: {},
        closable: true,
        severity: 'error',
        sticky: true,
        summary: errorMessage,
      })
    } finally {
      setIsRequestRunning(false)
    }
  }

  const submitForm = () => {
    selectedItems?.forEach(item => {
      // make a copy of the item
      const newItem = produce(item, draft => {
        draft.Status = 'REJECTED'
      })

      // put for despatchAdviceItem
      const response = requestPutAllowanceChargesById(
        invoiceId,
        item.Id!,
        newItem,
      )

      // return response header
      return response
    })
  }

  return (
    <Button
      label={t('common.buttons.reject')}
      icon="pi pi-times"
      className="p-button-outlined mr-2 mb-2"
      onClick={onSubmit}
      disabled={!selectedItems?.length}
      loading={isRequestRunning}
      visible={config.invoice.rejectAllowanceCharges.enabled !== false}
    />
  )
}
